<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="140px"
      class="demo-ruleForm"
      size="small"
    >
      <el-form-item :label="$t('login.pass.email')" prop="email">
        <el-input v-model.trim="ruleForm.email" autocomplete="off" clearable :placeholder="$t('login.pass.placeholder.inputEmail')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('login.pass.verificationCode')" prop="captcha">
        <el-input v-model.trim="ruleForm.captcha" autocomplete="off" clearable :placeholder="$t('login.pass.placeholder.inputCode')">
          <template slot="append">
            <span class="code-btn disabled" v-if="sendingCode">{{ $t('login.pass.sendingCode') }}</span>
            <span class="code-btn disabled" v-else-if="codeCd">{{ $t('login.pass.getCodeCountdown', [long]) }}</span>
            <span class="code-btn" v-else @click="sendCode">{{ $t('login.pass.getCode') }}</span>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('login.pass.newPassword')" prop="newpassword">
        <el-input type="password" v-model="ruleForm.newpassword" show-password autocomplete="new-password" :placeholder="$t('login.pass.placeholder.inputNewPassword')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('login.pass.confirmPassword')" prop="confirmPassword">
        <el-input type="password" v-model="ruleForm.confirmPassword" show-password autocomplete="new-password" :placeholder="$t('login.pass.placeholder.inputConfirmPassword')"></el-input>
      </el-form-item>
      <el-form-item class="form-actions">
        <el-button size="small" type="primary" :loading="submitting" @click="submitForm('ruleForm')">{{ $t('login.pass.submit') }}</el-button>
        <el-button size="small" @click="resetForm('ruleForm')">{{ $t('login.pass.reset') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { sendEmailCode, usersForgotPassword } from '@/api/login'

export default {
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (rule.required && !value) {
        callback(new Error(this.$t('login.pass.requiredMessage.confirmPassword')))
      } else if (value !== this.ruleForm.newpassword) {
        callback(new Error(this.$t('login.pass.formatMessage.passwordNotMatch')))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        email: '',
        captcha: '',
        newpassword: '',
        confirmPassword: ''
      },
      long: 60,
      codeCd: false,
      codeTimer: null,
      sendingCode: false,
      submitting: false,
      rules: {
        email: [
          { required: true, message: this.$t('login.pass.requiredMessage.email'), trigger: 'blur' },
          { type: 'email', message: this.$t('login.pass.formatMessage.email'), trigger: ['blur', 'change'] }
        ],
        captcha: [
          { required: true, message: this.$t('login.pass.requiredMessage.captcha'), trigger: 'blur' },
          { pattern: /^\d{4}$/, message: this.$t('login.pass.formatMessage.captcha'), trigger: 'blur' }
        ],
        newpassword: [
          { required: true, message: this.$t('login.pass.requiredMessage.newPassword'), trigger: 'blur' },
          { min: 6, message: this.$t('login.pass.formatMessage.passwordLength'), trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  beforeDestroy() {
    this.clearCodeTimer()
  },
  methods: {
    // 发送用于重置密码的邮箱验证码
    sendCode() {
      if (this.sendingCode || this.codeCd) return
      this.$refs.ruleForm.validateField('email', (errMsg) => {
        if (errMsg) return
        this.sendingCode = true
        sendEmailCode({
          email: this.ruleForm.email,
          event: 'resetpwd',
          lang: window.localStorage.getItem('lhkdLang') || 'en'
        }).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('login.pass.codeSent'))
            this.startCodeTimer()
          } else {
            this.$message.error(res.msg)
          }
        }).catch(error => {
          this.$message.error(error && error.msg ? error.msg : this.$t('login.pass.requestFailed'))
        }).finally(() => {
          this.sendingCode = false
        })
      })
    },
    startCodeTimer() {
      this.clearCodeTimer()
      this.codeCd = true
      this.long = 60
      this.codeTimer = setInterval(() => {
        this.long--
        if (this.long <= 0) {
          this.clearCodeTimer()
        }
      }, 1000)
    },
    clearCodeTimer() {
      if (this.codeTimer) {
        clearInterval(this.codeTimer)
        this.codeTimer = null
      }
      this.long = 60
      this.codeCd = false
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid || this.submitting) return
        this.submitting = true
        usersForgotPassword({
          email: this.ruleForm.email,
          captcha: this.ruleForm.captcha,
          newpassword: this.ruleForm.newpassword
        }).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('login.pass.resetSuccess'))
            this.$emit('ok')
          } else {
            this.$message.error(res.msg)
          }
        }).catch(error => {
          this.$message.error(error && error.msg ? error.msg : this.$t('login.pass.requestFailed'))
        }).finally(() => {
          this.submitting = false
        })
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.clearCodeTimer()
    }
  }
}
</script>

<style lang="scss" scoped>
.code-btn {
  color: #409EFF;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}

.code-btn.disabled {
  color: #909399;
  cursor: default;
}

.form-actions {
  margin-bottom: 0;
  text-align: right;
}
</style>
